import React, { lazy, Suspense } from 'react';

import type { CreateTeamDialogWrapperProps } from './main';

type LazyCreateTeamDialogComponent = ((
	props: CreateTeamDialogWrapperProps,
) => React.ReactElement) & {
	displayName?: string;
};

const CreateTeamDialogSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_create-team-dialog" */ './main'
		),
);

const LazyCreateTeamDialog: LazyCreateTeamDialogComponent = (props) => (
	<Suspense fallback={null}>
		<CreateTeamDialogSuspense {...props} />
	</Suspense>
);
LazyCreateTeamDialog.displayName = 'lazy(LazyCreateTeamDialog)';

export default LazyCreateTeamDialog;
